// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_H38D8 {
  min-height: 100vh;
}
.layout_nHwWP {
  margin-top: 3px;
  z-index: 0;
}
.contentLayout_ciaDa {
  margin: 24px 16px 0;
}
.content_BftUd {
  padding: 24px;
  background: #fff;
  min-height: 20px;
  margin-top: 20px;
}
.headerLayout_EI2Sc {
  display: flex;
  background: #fff;
  padding: 0;
}
.headerLayoutAlt__vR48 {
  position: sticky;
  top: 0;
  z-index: 1;
  width: 100%;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 0;
}
.headerRight_aTKno {
  display: flex;
  width: 65%;
  align-self: center;
  margin-left: 20px;
  margin-right: 35px;
}
.menuBorder_qoFaX {
  border-right: 1px solid #eeeff2;
  margin-top: 10px;
  margin-bottom: 10px;
}
.searchIconText_PYt7M {
  margin-bottom: 8px;
  margin-right: 4px;
}
.menuCollapse_xQaBg {
  float: left;
  width: '90%';
  align-self: center;
  display: flex;
}
.header_m39v7 {
  display: flex;
}
.trigger_oPb6V {
  margin-left: 100px;
  margin-right: 16px;
  align-self: center;
}
.menu_AjA7x {
  box-shadow: #e4ecef;
  position: relative;
  margin-top: 2px;
}
.menu_AjA7x .ant-menu-horizontal_VQhFR {
  border: none;
}
.menu_AjA7x .ant-menu-horizontal_VQhFR > .ant-menu-submenu_W2dxr {
  float: right;
}
.menu_AjA7x .ant-menu-submenu-title_wLN7E {
  width: 64px;
  height: 64px;
  text-align: center;
  padding-top: 15px;
}
.menu-logo_EXEtu {
  background-repeat: no-repeat;
  background-position: center;
  height: 35px;
  background-size: 100%;
  margin: 20px;
  color: #ffffff;
}
.navText_ix2Ka {
  font-size: 16px;
  font-weight: 700;
  color: white;
  vertical-align: super;
}
.avatarWidth_hgNg9 {
  width: 200px;
}
.overlay_ty2Gu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.418) !important;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.services_Unx2k {
  margin-bottom: 20px;
}
.servicesform_hhbSn {
  width: 100%;
}
.clintDropdownListDiv_YhKV2 {
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 18px;
}
.clientDropdownListSpan_Qyhsw {
  width: 20px;
  font-size: 12px;
}
.clientDropdownListSpan2_x2DWH {
  width: 20px;
  font-size: 12px;
}
::-webkit-scrollbar {
  width: 14px;
}
::-webkit-scrollbar-track {
  border-radius: 15px;
  margin: 10px;
  box-shadow: inset 7px 10px 12px transparent;
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  border-radius: 9999px;
  background-color: #aaaaaa;
}
/* adds 'n' after "Su"*/
.my-calendar_LbLky table thead tr > th:nth-child(1)::after {
  content: 'n';
}
/* adds 'n' after "Mo"*/
.my-calendar_LbLky table thead tr > th:nth-child(2)::after {
  content: 'n';
}
/* ... etc., etc., ....*/
.my-calendar_LbLky table thead tr > th:nth-child(3)::after {
  content: 'e';
}
.my-calendar_LbLky table thead tr > th:nth-child(4)::after {
  content: 'd';
}
.my-calendar_LbLky table thead tr > th:nth-child(5)::after {
  content: 'u';
}
.my-calendar_LbLky table thead tr > th:nth-child(6)::after {
  content: 'i';
}
.my-calendar_LbLky table thead tr > th:nth-child(7)::after {
  content: 't';
}
.headerChangedSide_kJhBg {
  display: flex;
  align-items: center;
  padding: 0 16px;
  position: relative;
}
.menuContainer_N87hW {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  flex-grow: 1;
  display: flex;
  align-items: center;
  scrollbar-width: none;
}
.scrollableMenu_G8Aoq {
  display: inline-flex;
}
.scrollButton__vzkq {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}
.scrollButton__vzkq:first-child {
  left: 0;
}
.scrollButton__vzkq:last-child {
  right: 0;
}
.footerTextStyle_Q9Hxc {
  text-align: left;
  position: relative;
  bottom: 0;
  background: none;
  margin-bottom: 5px;
}
.footerTextDefaultStyle_m5wu8 {
  text-align: left;
  position: fixed;
  bottom: 0;
  background: none;
  margin-bottom: 5px;
}
.dark-theme_J_ooS {
  background-color: #121212;
  color: #e0e0e0;
}
.dark-theme_J_ooS .ant-layout_wmOO2 {
  background-color: #121212;
}
.dark-theme_J_ooS .ant-layout-header_VpS0E,
.dark-theme_J_ooS .ant-layout-footer_K2r8b {
  background-color: #2FB153;
}
.dark-theme_J_ooS .ant-breadcrumb_XDVSN {
  color: #e0e0e0;
}
.nameAndDetails_Ma9hb {
  font-size: 12px;
  font-weight: 300;
}
.divider_dThO9 {
  width: 4px;
  background-color: #cdd0c9;
  position: relative;
  margin-left: -1px;
  transition: background-color 0.3s ease;
}
.divider_dThO9:hover {
  background-color: #ffffff;
}
.iconButton_zwehM {
  position: relative;
  transform: translateY(-50%);
  top: 30px;
  right: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  background-color: #ffffff;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
  color: #999999;
  font-weight: 600;
}
.iconButton_zwehM:hover {
  background-color: #1890ff;
  color: #ffffff;
}
.ant-menu-item_ovG2r:hover {
  background-color: #1890ff !important;
  /* Blue */
}
/* Selected item background color - Red */
.ant-menu-item-selected_KDSdK {
  background-color: #ff4d4f !important;
  /* Red */
}
/* Optional: Customize text color for better contrast */
.ant-menu-item-selected_KDSdK .ant-menu-title-content_g8Crr,
.ant-menu-item_ovG2r:hover .ant-menu-title-content_g8Crr {
  color: #ffffff !important;
  /* White text on hover and selected */
}
`, "",{"version":3,"sources":["webpack://./src/Layouts/Less/style.less"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;AAEA;EACI,eAAA;EACA,UAAA;AAAJ;AAGA;EACI,mBAAA;AADJ;AAIA;EACI,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAFJ;AAKA;EACI,aAAA;EACA,gBAAA;EACA,UAAA;AAHJ;AAMA;EACI,gBAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;AAJJ;AAOA;EACI,aAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AALJ;AAQA;EACI,+BAAA;EACA,gBAAA;EACA,mBAAA;AANJ;AASA;EACI,kBAAA;EACA,iBAAA;AAPJ;AAUA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AARJ;AAWA;EACI,aAAA;AATJ;AAYA;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;AAVJ;AAaA;EAOI,mBAAA;EACA,kBAAA;EACA,eAAA;AAjBJ;AAQA;EAKQ,YAAA;AAVR;AAOQ;EACI,YAAA;AALZ;AAEA;EAWQ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAVR;AAcA;EACI,4BAAA;EACA,2BAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAZJ;AAeA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;AAbJ;AAgBA;EACI,YAAA;AAdJ;AAgBA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAdJ;AA6BA;EACI,mBAAA;AA3BJ;AA6BA;EACI,WAAA;AA3BJ;AA8BA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AA5BJ;AA8BA;EACI,WAAA;EACA,eAAA;AA5BJ;AA8BA;EACI,WAAA;EACA,eAAA;AA5BJ;AA+BA;EACI,WAAA;AA7BJ;AAgCA;EACI,mBAAA;EACA,YAAA;EACA,2CAAA;EACA,6BAAA;AA9BJ;AAgCA;EACI,kCAAA;EACA,4BAAA;EACA,qBAAA;EACA,yBAAA;AA9BJ;AACA,uBAAuB;AAgCvB;EACI,YAAA;AA9BJ;AACA,uBAAuB;AAiCvB;EACI,YAAA;AA/BJ;AACA,wBAAwB;AAkCxB;EACI,YAAA;AAhCJ;AAmCA;EACI,YAAA;AAjCJ;AAoCA;EACI,YAAA;AAlCJ;AAqCA;EACI,YAAA;AAnCJ;AAsCA;EACI,YAAA;AApCJ;AAuCA;EACI,aAAA;EACA,mBAAA;EAEA,eAAA;EACA,kBAAA;AAtCJ;AAyCA;EACI,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AAvCJ;AA0CA;EACI,oBAAA;AAxCJ;AA2CA;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;AAzCJ;AA4CA;EACI,OAAA;AA1CJ;AA6CA;EACI,QAAA;AA3CJ;AA8CA;EACI,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AA5CJ;AA+CA;EACI,gBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AA7CJ;AAoDA;EACI,yBAAA;EACA,cAAA;AAlDJ;AAgDA;EAKQ,yBAAA;AAlDR;AA6CA;;EAUQ,yBAAA;AAnDR;AAyCA;EAcQ,cAAA;AApDR;AAuDA;EACI,eAAA;EACA,gBAAA;AArDJ;AAwDA;EACI,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sCAAA;AAtDJ;AAyDA;EACI,yBAAA;AAvDJ;AA0DA;EACI,kBAAA;EACA,2BAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sCAAA;EACA,cAAA;EACA,gBAAA;AAxDJ;AA2DA;EACI,yBAAA;EACA,cAAA;AAzDJ;AA4DA;EACI,oCAAA;EA1DF,SAAS;AACX;AACA,yCAAyC;AA4DzC;EACI,oCAAA;EA1DF,QAAQ;AACV;AACA,uDAAuD;AA4DvD;;EAEI,yBAAA;EA1DF,qCAAqC;AACvC","sourcesContent":[".main {\n    min-height: 100vh;\n}\n\n.layout {\n    margin-top: 3px;\n    z-index: 0;\n}\n\n.contentLayout {\n    margin: 24px 16px 0;\n}\n\n.content {\n    padding: 24px;\n    background: #fff;\n    min-height: 20px;\n    margin-top: 20px;\n}\n\n.headerLayout {\n    display: flex;\n    background: #fff;\n    padding: 0;\n}\n\n.headerLayoutAlt {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    background: #fff;\n    padding: 0;\n}\n\n.headerRight {\n    display: flex;\n    width: 65%;\n    align-self: center;\n    margin-left: 20px;\n    margin-right: 35px;\n}\n\n.menuBorder {\n    border-right: 1px solid #eeeff2;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.searchIconText {\n    margin-bottom: 8px;\n    margin-right: 4px;\n}\n\n.menuCollapse {\n    float: left;\n    width: '90%';\n    align-self: center;\n    display: flex;\n}\n\n.header {\n    display: flex;\n}\n\n.trigger {\n    margin-left: 100px;\n    margin-right: 16px;\n    align-self: center;\n}\n\n.menu {\n    .ant-menu-horizontal {\n        & > .ant-menu-submenu {\n            float: right;\n        }\n        border: none;\n    }\n    box-shadow: #e4ecef;\n    position: relative;\n    margin-top: 2px;\n    .ant-menu-submenu-title {\n        width: 64px;\n        height: 64px;\n        text-align: center;\n        padding-top: 15px;\n    }\n}\n\n.menu-logo {\n    background-repeat: no-repeat;\n    background-position: center;\n    height: 35px;\n    background-size: 100%;\n    margin: 20px;\n    color: #ffffff;\n}\n\n.navText {\n    font-size: 16px;\n    font-weight: 700;\n    color: white;\n    vertical-align: super;\n}\n\n.avatarWidth {\n    width: 200px;\n}\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.418) !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n// .overlay {\n//     position: fixed;\n//     top: 0;\n//     left: 50;\n//     width: 80%;\n//     height: 100%;\n//     background-color: rgba(255, 255, 255, 0.418) !important;\n//     display: flex;\n//     justify-content: center;\n//     align-items: center;\n//     z-index: 9999;\n// }\n.services {\n    margin-bottom: 20px;\n}\n.servicesform {\n    width: 100%;\n}\n\n.clintDropdownListDiv {\n    display: flex;\n    align-items: center;\n    font-weight: 700;\n    font-size: 18px;\n}\n.clientDropdownListSpan {\n    width: 20px;\n    font-size: 12px;\n}\n.clientDropdownListSpan2 {\n    width: 20px;\n    font-size: 12px;\n}\n\n::-webkit-scrollbar {\n    width: 14px;\n}\n\n::-webkit-scrollbar-track {\n    border-radius: 15px;\n    margin: 10px;\n    box-shadow: inset 7px 10px 12px transparent;\n    background-color: transparent;\n}\n::-webkit-scrollbar-thumb {\n    border: 4px solid rgba(0, 0, 0, 0);\n    background-clip: padding-box;\n    border-radius: 9999px;\n    background-color: #aaaaaa;\n}\n/* adds 'n' after \"Su\"*/\n.my-calendar table thead tr > th:nth-child(1)::after {\n    content: 'n';\n}\n\n/* adds 'n' after \"Mo\"*/\n.my-calendar table thead tr > th:nth-child(2)::after {\n    content: 'n';\n}\n\n/* ... etc., etc., ....*/\n.my-calendar table thead tr > th:nth-child(3)::after {\n    content: 'e';\n}\n\n.my-calendar table thead tr > th:nth-child(4)::after {\n    content: 'd';\n}\n\n.my-calendar table thead tr > th:nth-child(5)::after {\n    content: 'u';\n}\n\n.my-calendar table thead tr > th:nth-child(6)::after {\n    content: 'i';\n}\n\n.my-calendar table thead tr > th:nth-child(7)::after {\n    content: 't';\n}\n\n.headerChangedSide {\n    display: flex;\n    align-items: center;\n    // background: #fff;\n    padding: 0 16px;\n    position: relative;\n}\n\n.menuContainer {\n    overflow-x: auto;\n    overflow-y: hidden;\n    white-space: nowrap;\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    scrollbar-width: none;\n}\n\n.scrollableMenu {\n    display: inline-flex;\n}\n\n.scrollButton {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 1;\n}\n\n.scrollButton:first-child {\n    left: 0;\n}\n\n.scrollButton:last-child {\n    right: 0;\n}\n\n.footerTextStyle {\n    text-align: left;\n    position: relative;\n    bottom: 0;\n    background: none;\n    margin-bottom: 5px;\n}\n\n.footerTextDefaultStyle {\n    text-align: left;\n    position: fixed;\n    bottom: 0;\n    background: none;\n    margin-bottom: 5px;\n}\n\n@primary-color: #1f1f1f;\n@background-color: #121212;\n@text-color: #e0e0e0;\n\n.dark-theme {\n    background-color: @background-color;\n    color: @text-color;\n\n    .ant-layout {\n        background-color: @background-color;\n    }\n\n    .ant-layout-header,\n    .ant-layout-footer {\n        background-color: @primary-color;\n    }\n\n    .ant-breadcrumb {\n        color: @text-color;\n    }\n}\n.nameAndDetails {\n    font-size: 12px;\n    font-weight: 300;\n}\n\n.divider {\n    width: 4px;\n    background-color: #cdd0c9;\n    position: relative;\n    margin-left: -1px;\n    transition: background-color 0.3s ease;\n}\n\n.divider:hover {\n    background-color: #ffffff;\n}\n\n.iconButton {\n    position: relative;\n    transform: translateY(-50%);\n    top: 30px;\n    right: 9px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 25px;\n    height: 25px;\n    background-color: #ffffff;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    color: #999999;\n    font-weight: 600;\n}\n\n.iconButton:hover {\n    background-color: #1890ff;\n    color: #ffffff;\n}\n\n.ant-menu-item:hover {\n    background-color: #1890ff !important; /* Blue */\n}\n\n/* Selected item background color - Red */\n.ant-menu-item-selected {\n    background-color: #ff4d4f !important; /* Red */\n}\n\n/* Optional: Customize text color for better contrast */\n.ant-menu-item-selected .ant-menu-title-content,\n.ant-menu-item:hover .ant-menu-title-content {\n    color: #ffffff !important; /* White text on hover and selected */\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `main_H38D8`,
	"layout": `layout_nHwWP`,
	"contentLayout": `contentLayout_ciaDa`,
	"content": `content_BftUd`,
	"headerLayout": `headerLayout_EI2Sc`,
	"headerLayoutAlt": `headerLayoutAlt__vR48`,
	"headerRight": `headerRight_aTKno`,
	"menuBorder": `menuBorder_qoFaX`,
	"searchIconText": `searchIconText_PYt7M`,
	"menuCollapse": `menuCollapse_xQaBg`,
	"header": `header_m39v7`,
	"trigger": `trigger_oPb6V`,
	"menu": `menu_AjA7x`,
	"ant-menu-horizontal": `ant-menu-horizontal_VQhFR`,
	"ant-menu-submenu": `ant-menu-submenu_W2dxr`,
	"ant-menu-submenu-title": `ant-menu-submenu-title_wLN7E`,
	"menu-logo": `menu-logo_EXEtu`,
	"navText": `navText_ix2Ka`,
	"avatarWidth": `avatarWidth_hgNg9`,
	"overlay": `overlay_ty2Gu`,
	"services": `services_Unx2k`,
	"servicesform": `servicesform_hhbSn`,
	"clintDropdownListDiv": `clintDropdownListDiv_YhKV2`,
	"clientDropdownListSpan": `clientDropdownListSpan_Qyhsw`,
	"clientDropdownListSpan2": `clientDropdownListSpan2_x2DWH`,
	"my-calendar": `my-calendar_LbLky`,
	"headerChangedSide": `headerChangedSide_kJhBg`,
	"menuContainer": `menuContainer_N87hW`,
	"scrollableMenu": `scrollableMenu_G8Aoq`,
	"scrollButton": `scrollButton__vzkq`,
	"footerTextStyle": `footerTextStyle_Q9Hxc`,
	"footerTextDefaultStyle": `footerTextDefaultStyle_m5wu8`,
	"dark-theme": `dark-theme_J_ooS`,
	"ant-layout": `ant-layout_wmOO2`,
	"ant-layout-header": `ant-layout-header_VpS0E`,
	"ant-layout-footer": `ant-layout-footer_K2r8b`,
	"ant-breadcrumb": `ant-breadcrumb_XDVSN`,
	"nameAndDetails": `nameAndDetails_Ma9hb`,
	"divider": `divider_dThO9`,
	"iconButton": `iconButton_zwehM`,
	"ant-menu-item": `ant-menu-item_ovG2r`,
	"ant-menu-item-selected": `ant-menu-item-selected_KDSdK`,
	"ant-menu-title-content": `ant-menu-title-content_g8Crr`
};
export default ___CSS_LOADER_EXPORT___;
